import { useSelector } from 'react-redux'
import { ThemeSwitcherState } from '../themeSlice'
import { useMemo } from 'react'
import { themeFactory } from '@eventops/chronotrack-ctlive-mui'

const useCurrentTheme = () => {
  const darkMode = useSelector<{theme: ThemeSwitcherState}, boolean>(state => !!state.theme?.darkMode)
  const darkTheme = useMemo(() => themeFactory(darkMode), [darkMode])
  return darkTheme
}

export default useCurrentTheme
